var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"nav"}),_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }